// React
import React from 'react'
import PropTypes from 'prop-types'

export const Day = ({ day }) => {
  return (
    <div className="DayPicker-Day__wrapper">
      <div className="DayPicker-Day__inner">
        <div className="DayPicker-Day__date">{day.getDate()}</div>
      </div>
    </div>
  )
}

Day.propTypes = {
  day: PropTypes.instanceOf(Date).isRequired
}
